// sdk.js
import axios from 'axios';

let token;
let baseUrl = 'https://api.kevi.io/client/';
let insertionsBaseUrl = 'https://api.kevi.io/';
// let baseUrl = 'http://api.local.kevi.io/client/';
// let insertionsBaseUrl = 'http://api.local.kevi.io/';

export function init(authToken) {
    token = authToken;
}

export function request(method, url, data = {}) {
    return axios({
        method,
        url: baseUrl + url,
        data,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
}

export function getData() {
    return request('get', 'dashboard');
}

export function useReward(id) {
    return request('post', 'use-reward/' + id);
}

export function getFormLinks() {
    return request('get', 'form/links');
}

export async function getSmartInsertions(id) {
    const response = await request('get', 'smart-insertions/' + id);
    if (!response.data) {
        return [];
    }
    return response.data.filter(insertion => {
        if (window.localStorage) {
            const hiddenFromMe = window.localStorage.getItem('hideInsertionFromMe_' + insertion.id);
            if (hiddenFromMe) {
                return false;
            }
            const stopTime = window.localStorage.getItem('hideInsertion_' + insertion.id);
            if (stopTime && new Date().getTime() < stopTime) {
                return false;
            }
        }
        if (window.sessionStorage) {
            const sessionHide = window.sessionStorage.getItem('hideInsertionSession_' + insertion.id);
            if (sessionHide) {
                return false;
            }
        }
        return true;
    });
}

export function getSmartInsertionHtmlUrl(id, field) {
    field = encodeURIComponent(field);
    return insertionsBaseUrl + `smart-insertions/${id}/html?field=${field}`;
}

export function hideInsertion(id) {
    if (window.localStorage) {
        window.localStorage.setItem('hideInsertionFromMe_' + id, true);
    }
}

export function hideInsertionForHours(id, hours) {
    /*
        Save on local storage the insertion id so we can filter it out and not show it again on this device.
    */
    const finalTime = new Date().getTime() + hours * 60 * 60 * 1000;
    if (window.localStorage) {
        window.localStorage.setItem('hideInsertion_' + id, finalTime);
    }
}

export function hideInsertionForSession(id) {
    if (window.sessionStorage) {
        window.sessionStorage.setItem('hideInsertionSession_' + id, true);
    }
}
